// Dutch names for the sticker-shelf rewards and the football cups.
//
// These are laid over the data at DISPLAY time only. `REWARDS[].name` is a KEY:
// `FRIEND_DRAWINGS[r.name]` looks up the drawable friend by its English name, so
// translating the data itself would silently break every "tap a friend to draw
// it" button. Only what the child reads is translated.
//
// Each entry carries the definite article the sentence needs — "de " for common
// gender, "het " for neuter (Dutch merged m/f into one common gender). Dutch has
// no elision (no "l'"), so article is derivable from the word's gender.
//
// Names are capitalized: Dutch capitalises all nouns, even mid-sentence.

export interface RewardNl {
  name: string;
  /** Definite article, with its trailing space: "de " or "het ". */
  article: string;
}

/** English reward name (the key into FRIEND_DRAWINGS) → Dutch. */
export const REWARDS_NL: Record<string, RewardNl> = {
  Mouse: { name: "Muis", article: "de " },
  Frog: { name: "Kikker", article: "de " },
  Hamster: { name: "Hamster", article: "de " },
  Duck: { name: "Eend", article: "de " },
  Bunny: { name: "Konijn", article: "het " },
  Cat: { name: "Kat", article: "de " },
  Fox: { name: "Vos", article: "de " },
  Dog: { name: "Hond", article: "de " },
  Penguin: { name: "Pinguïn", article: "de " },
  Pig: { name: "Varken", article: "het " },
  Pony: { name: "Pony", article: "de " },
  Cow: { name: "Koe", article: "de " },
  Lion: { name: "Leeuw", article: "de " },
  Horse: { name: "Paard", article: "het " },
  Bear: { name: "Beer", article: "de " },
  Elephant: { name: "Olifant", article: "de " },
  Whale: { name: "Walvis", article: "de " },
  Dinosaur: { name: "Dinosaurus", article: "de " },
};

/** English cup name → Dutch. */
export const CUPS_NL: Record<string, RewardNl> = {
  "Kickoff Cup": { name: "Aftrapbeker", article: "de " },
  "Bronze Cup": { name: "Bronzen beker", article: "de " },
  "Silver Cup": { name: "Zilveren beker", article: "de " },
  "Gold Cup": { name: "Gouden beker", article: "de " },
  "Champions Cup": { name: "Kampioenenbeker", article: "de " },
};
